import * as React from "react";
import { Link } from "react-router-dom";
import Logo from "./../../assets/images/logo.png";
import $ from "jquery";
import CONSTANT from "./../../constant";
import { getCookie, getStorage } from "../../utils";

class HrHeader extends React.Component<any, any> {
  componentDidMount() {
  }

  render() {
    const ud = getCookie(CONSTANT.cookie.userDetail);
    const permissions = getStorage(CONSTANT.cookie.permissions);

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="navbar navbar-expand-lg">
            <div
              className="left-menu collapse navbar-collapse flex-column"
              id="navbarNav"
            >
              <div className="logo"></div>
              <ul>
                <li>
                  <Link to={CONSTANT.component.userFileList.url}>
                    <i className="fa fa-file" /> Property Return User List
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default HrHeader;
